import React, { Component } from "react"
import PropTypes from "prop-types";

class StatBox extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    number: PropTypes.number.isRequired,
  };
  render() {
    const { title, number, color, subtitle } = this.props

    return (
      <div className="uk-width-1-2@m aps-dashboard-body-stats-card-margin">
        <div className="aps-dashboard-body-stats-card uk-card uk-card-default uk-card-small uk-card-body aps-dashboard-body-stats-card-first" style={{backgroundColor: color}}>
          <div className="uk-card-title uk-flex uk-flex-between">
            <h3 className="aps-dashboard-body-stats-card-title">{number}</h3>
            <span className="aps-dashboard-body-white-arrow" data-uk-icon="icon: arrow-up; ratio: 1.7"></span>
          </div>
          <p className="aps-dashboard-body-stats-card-content">{title} <br/> {subtitle}</p>
        </div>
      </div>
    )
  }
}

export default StatBox



// WEBPACK FOOTER //
// ./src/components/StatBox/index.js